import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  compact?: boolean;
}

/**
 * 空态。
 *
 * 设计系统（DESIGN.md §10）：
 * - 边框从 border-dashed 细虚线改成 birch-200 实线浅（"已准备好，只是还没数据"
 *   比"这里什么都没有"更积极）
 * - 图标统一 48px，无彩色圆底（去 AI 味）
 * - 字号 + 颜色全部走木色 token
 */
export default function EmptyState({ icon: Icon, title, description, action, compact }: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-md border border-birch-200 bg-white text-center ${
        compact ? 'px-4 py-8' : 'px-6 py-12'
      }`}
    >
      {Icon ? (
        <div className="mb-3 text-oak-300">
          <Icon className="h-12 w-12" strokeWidth={1.25} />
        </div>
      ) : null}
      <div className="text-sm font-medium text-walnut-900">{title}</div>
      {description ? <div className="mt-1 text-xs text-oak-500">{description}</div> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
